import i18n from '../../../i18n';
import {IElement} from '../../../incase-domain/elements';
import {ELEMENT} from '../../../incase-domain/elements/base/ElementTypes';
import {getEmptyElement} from '../../element';

function generateTitleSubtitleTemplate(slideId: string): IElement[] {
    const titleText = `<h1 style="text-align: center">${i18n.t('template.text.title')}</h1>`;
    const subtitleText = `<h2 style="text-align: center">${i18n.t('template.text.subtitle')}</h2>`;
    return [
        {
            ...getEmptyElement(slideId, ELEMENT.STATIC_TEXT),
            name: 'Title',
            text: titleText,
            yPosition: 25,
            xPosition: 20,
            width: '60%',
            height: '15%',
        },
        {
            ...getEmptyElement(slideId, ELEMENT.STATIC_TEXT),
            name: 'Subtitle',
            text: subtitleText,
            yPosition: 40,
            xPosition: 10,
            width: '80%',
            height: '15%',
        },
    ];
}

export default generateTitleSubtitleTemplate;
